export const DASHBOARDLIST_SEARCH = 'DASHBOARDLIST_SEARCH';
export const DASHBOARDLIST_PAGE = 'DASHBOARDLIST_PAGE';
export const DASHBOARDLIST_DATE = 'DASHBOARDLIST_DATE';